export default __webpack_public_path__ + "static/media/vehicle_active_back_right.c6e60c1a.svg";